import React, { FC } from 'react';
import { HeaderTitle } from '../../components/header-title/header-title';
import { AssistantMessage, Container } from '@plataformaxvia/design-system';
import { AssistantMessageContainer, BaseSiteMap, LinkItem } from './style';

export interface SiteMapItem {
  label: string;
  link: string;
  children?: SiteMapItem[];
}

export interface SiteMapProps {
  items: SiteMapItem[];
}

export const SiteMap: FC<SiteMapProps> = ({ items }) => {
  return (
    <>
      <HeaderTitle title="Mapa do site" />
      <BaseSiteMap>
        <Container>
          <div className="xvia-container">
            <AssistantMessageContainer>
              <AssistantMessage variant="success">
                <strong>Está perdido ou procurando algo específico?</strong>{' '}
                <br /> O nosso <strong>Mapa do Site</strong> foi criado para
                ajudar você a se localizar. <br />
                <br /> Abaixo, listamos todos os nossos links em uma estrutura
                hierárquica para que você chegue ao seu destino com apenas um
                clique.
              </AssistantMessage>
            </AssistantMessageContainer>
            <ul>
              {items.map((item) => (
                <LinkItem key={item.link}>
                  <a href={item.link}>{item.label}</a>
                  {item.children && (
                    <ul>
                      {item.children.map((child) => (
                        <LinkItem key={child.link}>
                          <a href={child.link}>{child.label}</a>
                        </LinkItem>
                      ))}
                    </ul>
                  )}
                </LinkItem>
              ))}
            </ul>
          </div>
        </Container>
      </BaseSiteMap>
    </>
  );
};
